import { useMemo } from 'react';

import { OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS } from 'global/constants';
import { OutcomesFragment } from 'approot/shared/graphql/outcomes/__generated__/OutcomesFragment';
import { InquisitiveEnglishContentArea } from 'global/graphql/scalars.type';
import { formatEnglishContentAreaString } from 'approot/shared/logic/format-english-content-area';
import { BadgeStyled } from 'approot/shared/badge/badge.style';

type Props = {
  englishContentArea?: InquisitiveEnglishContentArea[] | null;
  performanceExpectations?: OutcomesFragment[] | null;
};

const ContentPageHeaderText = ({
  englishContentArea,
  performanceExpectations,
}: Props) => {
  const pe = useMemo(() => {
    return performanceExpectations?.find(
      outcome => outcome.category === OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS
    );
  }, [performanceExpectations]);

  return (
    <>
      {englishContentArea && englishContentArea.length > 0 ? (
        <BadgeStyled>
          {formatEnglishContentAreaString(englishContentArea)}
        </BadgeStyled>
      ) : null}
      {pe?.dciArrangements && <BadgeStyled>{pe.dciArrangements}</BadgeStyled>}
    </>
  );
};

export default ContentPageHeaderText;
